import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["data-experiment-university-id", "href", "target"]
const _hoisted_2 = {
  key: 0,
  class: "CardHeader"
}
const _hoisted_3 = { class: "StudyName" }
const _hoisted_4 = {
  key: 0,
  class: "IncentiveWrapper"
}
const _hoisted_5 = { class: "PartOne" }
const _hoisted_6 = {
  key: 0,
  class: "BestFitSearchCard ExtraLargeScreen"
}
const _hoisted_7 = ["data-study-id"]
const _hoisted_8 = ["data-credits", "data-education_level", "data-delivery_method", "data-degree_type"]
const _hoisted_9 = { class: "FavouritingSection" }
const _hoisted_10 = ["data-study-id"]
const _hoisted_11 = {
  key: 1,
  class: "IncentiveWrapper"
}
const _hoisted_12 = { class: "PartOne" }
const _hoisted_13 = {
  key: 0,
  class: "BestFitSearchCard DesktopOnlyBlock"
}
const _hoisted_14 = ["data-study-id"]
const _hoisted_15 = { class: "FavouritingSection" }
const _hoisted_16 = ["data-study-id"]
const _hoisted_17 = {
  key: 1,
  class: "CardHeader CardHeardCompareMobile"
}
const _hoisted_18 = { class: "HeaderContainer" }
const _hoisted_19 = ["data-credits", "data-education_level", "data-delivery_method", "data-degree_type"]
const _hoisted_20 = { class: "FavouritingSection" }
const _hoisted_21 = ["data-study-id"]
const _hoisted_22 = {
  key: 2,
  class: "CardHeader"
}
const _hoisted_23 = { class: "StudyName" }
const _hoisted_24 = { class: "SecondaryFacts DesktopOnlyBlock" }
const _hoisted_25 = { class: "StudyInfo" }
const _hoisted_26 = { class: "BestfitContainer" }
const _hoisted_27 = {
  key: 0,
  class: "BestFitSearchCard MobileOnlyBlock"
}
const _hoisted_28 = ["data-study-id"]
const _hoisted_29 = { class: "KeyFacts" }
const _hoisted_30 = {
  key: 0,
  class: "ScholarshipIncentiveLabel isDesktop"
}
const _hoisted_31 = {
  key: 1,
  class: "TuitionFeeDiscount"
}
const _hoisted_32 = {
  key: 0,
  class: "TuitionValueOriginal"
}
const _hoisted_33 = { class: "TuitionAmount" }
const _hoisted_34 = { class: "CurrencyUnit" }
const _hoisted_35 = {
  key: 1,
  class: "TuitionValueScholarshipDiscount"
}
const _hoisted_36 = {
  key: 2,
  class: "TuitionFee"
}
const _hoisted_37 = {
  key: 0,
  class: "TuitionValue"
}
const _hoisted_38 = {
  key: 1,
  class: "TuitionValue"
}
const _hoisted_39 = {
  key: 2,
  class: "UnknownTuitionValue"
}
const _hoisted_40 = { class: "Duration" }
const _hoisted_41 = {
  key: 0,
  class: "ScholarshipIncentiveLabel isMobile"
}
const _hoisted_42 = {
  key: 1,
  class: "DurationValue"
}
const _hoisted_43 = {
  key: 2,
  class: "UnknownDurationValue"
}
const _hoisted_44 = { class: "OrganisationInfoContainer" }
const _hoisted_45 = { class: "OrganisationLogoAndNameContainer" }
const _hoisted_46 = ["src", "alt"]
const _hoisted_47 = { class: "NameLocation" }
const _hoisted_48 = { class: "OrganisationName" }
const _hoisted_49 = { class: "OrganisationLocation" }
const _hoisted_50 = {
  key: 0,
  class: "GlobalPositionPercentageContainer"
}
const _hoisted_51 = {
  class: "GlobalPositionPercentageContainer",
  ref: "rankingPercentageRef"
}
const _hoisted_52 = { class: "GlobalPositionPercentageValue" }
const _hoisted_53 = { class: "StudyCardFooter" }
const _hoisted_54 = { class: "CompareAndFeaturedContainer" }
const _hoisted_55 = {
  key: 0,
  class: "Promoted"
}
const _hoisted_56 = ["data-study-id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StudyCardTrackingInformation = _resolveComponent("StudyCardTrackingInformation")!

  return (_openBlock(), _createElementBlock("a", {
    class: "SearchStudyCard js-bestFitStudycard js-studyCardExperiment",
    "data-experiment-university-id": _ctx.organisationId,
    href: _ctx.programmeLink,
    target: _ctx.isMobile ? '_self' : '_blank',
    onValidated_impression: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.trackImpression && _ctx.trackImpression(...args))),
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.trackClick && _ctx.trackClick(...args)))
  }, [
    _createElementVNode("article", null, [
      _createCommentVNode(" Desktop header "),
      (!_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("header", _hoisted_2, [
            _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.title), 1 /* TEXT */),
            (_ctx.canShowIUIncentive)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    (_ctx.isMasters)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("div", {
                            class: "BestFitOverview",
                            "data-study-id": _ctx.id,
                            "data-widget-type": "button_icon",
                            "data-widget-location": "sblp_search_study_card",
                            "data-empty-text": "Check match"
                          }, null, 8 /* PROPS */, _hoisted_7)
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(["GlobalAccessInitiativeSearchCard", _ctx.hideTuitionFeePreDiscount ? 'Hide' : ''])
                    }, [
                      _createElementVNode("div", {
                        class: "ProfileQuestionnaire",
                        "data-incentive": "search_global_access_initiative_label",
                        "data-credits": _ctx.creditsCriteria,
                        "data-education_level": _ctx.level,
                        "data-delivery_method": _ctx.deliveryMethodCriteria,
                        "data-degree_type": _ctx.degreeTypeCriteria
                      }, null, 8 /* PROPS */, _hoisted_8)
                    ], 2 /* CLASS */),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", {
                        class: "WishlistButton",
                        "data-study-id": _ctx.id,
                        "data-button-type": "icon_only"
                      }, null, 8 /* PROPS */, _hoisted_10)
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    (_ctx.isMasters)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("div", {
                            class: "BestFitOverview",
                            "data-study-id": _ctx.id,
                            "data-widget-type": "button_icon",
                            "data-widget-location": "sblp_search_study_card",
                            "data-empty-text": "Check match"
                          }, null, 8 /* PROPS */, _hoisted_14)
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", {
                        class: "WishlistButton",
                        "data-study-id": _ctx.id,
                        "data-button-type": "icon_only"
                      }, null, 8 /* PROPS */, _hoisted_16)
                    ])
                  ])
                ]))
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Mobile header "),
      (_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("header", _hoisted_17, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_18, [
                (_ctx.canShowIUIncentive)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["GlobalAccessInitiativeSearchCard", _ctx.hideTuitionFeePreDiscount ? 'Hide' : ''])
                    }, [
                      _createElementVNode("div", {
                        class: "ProfileQuestionnaire",
                        "data-incentive": "search_global_access_initiative_label",
                        "data-credits": _ctx.creditsCriteria,
                        "data-education_level": _ctx.level,
                        "data-delivery_method": _ctx.deliveryMethodCriteria,
                        "data-degree_type": _ctx.degreeTypeCriteria
                      }, null, 8 /* PROPS */, _hoisted_19)
                    ], 2 /* CLASS */))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", {
                    class: "WishlistButton",
                    "data-study-id": _ctx.id,
                    "data-button-type": "icon_only"
                  }, null, 8 /* PROPS */, _hoisted_21)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("header", _hoisted_22, [
            _createElementVNode("h2", _hoisted_23, _toDisplayString(_ctx.title), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("span", _hoisted_24, [
        _createTextVNode(_toDisplayString(_ctx.degree) + " ", 1 /* TEXT */),
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "Divider" }, "/", -1 /* HOISTED */)),
        _createTextVNode(" " + _toDisplayString(_ctx.attendance) + " ", 1 /* TEXT */),
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "Divider" }, "/", -1 /* HOISTED */)),
        _createTextVNode(" " + _toDisplayString(_ctx.deliveryMethod), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          (_ctx.isMobile && _ctx.isMasters)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", {
                  class: "BestFitOverview",
                  "data-study-id": _ctx.id,
                  "data-widget-type": "button_icon",
                  "data-widget-location": "sblp_search_study_card",
                  "data-empty-text": "Check match"
                }, null, 8 /* PROPS */, _hoisted_28)
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_29, [
          (_ctx.canShowIUIncentive)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, _cache[4] || (_cache[4] = [
                _createElementVNode("div", {
                  class: "ProfileQuestionnaire",
                  "data-incentive": "search_scholarship_incentive_label"
                }, null, -1 /* HOISTED */)
              ])))
            : _createCommentVNode("v-if", true),
          (_ctx.canShowIUDiscountInfo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                (_ctx.tuitionFee !== null && !_ctx.hideTuitionFeePreDiscount)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.tuitionFee), 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.currencyUnit), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                (_ctx.tuitionFeeDiscount !== null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.tuitionFeeDiscount) + " " + _toDisplayString(_ctx.currencyUnit) + " / " + _toDisplayString(_ctx.tuitionUnit), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                (_ctx.tuitionFee === 'Free')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(_ctx.tuitionFee), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                (_ctx.tuitionFee !== null && _ctx.tuitionFee !== 'Free')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_ctx.tuitionFee) + " " + _toDisplayString(_ctx.currencyUnit) + " / " + _toDisplayString(_ctx.tuitionUnit), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                (_ctx.tuitionFee === null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, "Tuition unknown"))
                  : _createCommentVNode("v-if", true)
              ])),
          _createElementVNode("div", _hoisted_40, [
            (_ctx.canShowIUIncentive)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, _cache[5] || (_cache[5] = [
                  _createElementVNode("div", {
                    class: "ProfileQuestionnaire",
                    "data-incentive": "search_scholarship_incentive_label"
                  }, null, -1 /* HOISTED */)
                ])))
              : _createCommentVNode("v-if", true),
            (_ctx.duration !== null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(_ctx.duration), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            (_ctx.duration === null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, "Duration unknown"))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            (_ctx.canShowLogo)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "OrganisationLogo",
                  src: `${_ctx.organisationLogo}?fit=fill&fill=solid&fill-color=00FFFFFF&w=48&h=48&auto=format,compress`,
                  alt: `${_ctx.organisationName}`,
                  width: "48",
                  height: "48",
                  loading: "lazy"
                }, null, 8 /* PROPS */, _hoisted_46))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("strong", _hoisted_48, _toDisplayString(_ctx.organisationName), 1 /* TEXT */),
              _createElementVNode("strong", _hoisted_49, _toDisplayString(_ctx.location), 1 /* TEXT */)
            ])
          ]),
          (_ctx.canShowUniversityGlobalPositionPercentage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _cache[6] || (_cache[6] = _createElementVNode("i", { class: "lnr-podium GlobalPositionPercentageIcon" }, null, -1 /* HOISTED */)),
                  _cache[7] || (_cache[7] = _createTextVNode(" Ranked top ")),
                  _createElementVNode("b", _hoisted_52, _toDisplayString(_ctx.universityGlobalPositionPercentage) + "%", 1 /* TEXT */)
                ], 512 /* NEED_PATCH */)
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_53, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "CTA" }, "View Programme Information", -1 /* HOISTED */)),
        _createElementVNode("div", _hoisted_54, [
          (_ctx.enhanced)
            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                _createElementVNode("div", {
                  class: "Featured",
                  "data-study-id": _ctx.id
                }, " Featured ", 8 /* PROPS */, _hoisted_56)
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _createVNode(_component_StudyCardTrackingInformation, {
      id: _ctx.id,
      title: _ctx.title,
      enhanced: _ctx.enhanced
    }, null, 8 /* PROPS */, ["id", "title", "enhanced"])
  ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_1))
}